import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 3rem;

    ${p => p.theme.breakpoints.down('md')} {
        padding: 2rem 0 0;
    }
`;

const TitleContainer = styled.div`
    margin-bottom: 3rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    max-width: 30rem;

    ${p => p.theme.breakpoints.between('sm', 'lg')} {
        margin-bottom: 2rem;
    }
    ${p => p.theme.breakpoints.down('sm')} {
        max-width: 20rem;
        margin-bottom: 1rem;
    }
`;

const PageTitle = styled.h1`
    font-size: 1.875rem;
    font-weight: 400;
    margin-bottom: 0;
    color: ${p => p.theme.colors.white || ''};

    ${p => p.theme.breakpoints.down('sm')} {
        font-size: 1.5rem;
    }
`;

const PageSubTitle = styled.span`
    font-size: 1.25rem;
    margin-top: 1rem;
    font-weight: 400;
    text-align: center;
    color: rgba(255, 255, 255, 0.7);

    ${p => p.theme.breakpoints.down('sm')} {
        font-size: 1rem;
    }
`;

const SectionsContainer = styled.div`
    padding: 0 1.5rem 1rem 1.5rem;
    max-width: 71.25rem;
    background: #2a2a2a;
    border-radius: 4px;

    ${p => p.theme.breakpoints.down('sm')} {
        padding: 0 1rem 1rem 1rem;
    }
`;

const Section = styled.div`
    &:not(:last-of-type) {
        border-bottom: 1px solid rgba(255, 255, 255, 0.16);
    }
`;

const SectionTitle = styled.h2`
    font-size: 1.375rem;
    font-weight: 400;
    margin: 1.5rem 0;
    color: ${p => p.theme.colors.white || ''};

    ${p => p.theme.breakpoints.down('sm')} {
        font-size: 1.15rem;
    }
`;

const QuestionBlock = styled.div`
    margin-bottom: 1.5rem;
`;

const Question = styled.h3`
    font-size: 0.875rem;
    color: ${p => p.theme.colors.white || ''}
    margin-bottom: 0;

    ${p => p.theme.breakpoints.down('sm')} {
        font-size: .7rem;
    }
`;

const Answer = styled.div`
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.7);

    ${p => p.theme.breakpoints.down('sm')} {
        font-size: 0.7rem;
    }
`;

export {Container, TitleContainer, PageTitle, PageSubTitle, SectionsContainer, Section, SectionTitle, QuestionBlock, Question, Answer};
